import colors from '../../../../../public/colors'

/* eslint-disable */
export default theme => {
    const { mode } = theme.palette
    return {
    actionRow: {
        '& > button': {
            marginLeft: 'auto'
        },
        justifyContent: 'flex-end',
        height: '100%'
    },
    button: {
        '&.MuiButton-root': {
            border: '1px solid #006AC3',
            borderRadius: '4px',
            boxShadow: 'none',
            boxSizing: 'border-box',
            height: '40px',
            marginLeft: '10px',
            width: '104px'
        },
        '&:disabled': {
            borderColor: 'rgba(0, 0, 0, 0.12)'
        }
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        paddingLeft: '89%',
        
        [theme.breakpoints.down('sm')]: {
            paddingLeft: '66%',
        }
    },
    customLoader: {
        paddingTop : '18%',
        [theme.breakpoints.down('sm')]: {
            paddingTop : '32%',
        }
    },
    newLine: {
        whiteSpace: 'pre-line'
    },
    nextButton: {
        '&.MuiButton-root': {
            backgroundColor: '#FEDF01',
            borderRadius: '2px',
            boxShadow: 'none',
            boxSizing: 'border-box',
            color: '#003168',
            height: '32px',
            padding: '8px 16px',
            width: 'auto'
        }
    },
    nextButtonDisabled: {
        '&.MuiButton-root': {
            opacity: '50%'
        }
    },
    content: {
        height: '225px',
        padding: '25px 28px'
    },
    contentContainer: {
        borderRadius: '3px',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    },
    contentDivider: {
        paddingTop: '25px'
    },
    contentSection: {
        fontSize: '20px'
    },
    countdown: {
        position: 'relative',
    },
    countdownTypography: {
        left: '50%',
        position: 'absolute',
        top: '45%',
        transform: 'translate(-50%, -50%)',
    },
    divClass: {
        width: '100%'
    },
    divider: {
        background: '#FFC72A',
        padding: '2px',
        width: '50px'
    },
    fieldsContainer: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'space-between',
        width: '100%'
    },
    disabledLink: {
        alignSelf: 'start',
        cursor: 'default',
        display: 'flex',
        PointerEvents: 'none',
        color: 'rgba(0, 0, 0, 0.87)'
    },
    link: {
        alignSelf: 'start',
        display: 'flex'
    },
    show: {
        display: 'block'
    },
    hide: {
        display: 'none'
    },
    loader: {
        height: '100%',
        left: '0',
        position: 'absolute',
        top: '0',
        width: '100%',
        'z-index': '10'
    },
    successMsg: {
        color: theme.palette.success.main
    },
    root: {
        padding: theme.spacing(0, 2, 2, 2)
    },
    subTitle: {
        color: colors[mode].secondaryText,
        fontFamily: 'Roboto',
        fontSize: '14px',
        fontWeight: 400,
        letterSpacing: '0.17px',
        lineHeight: '20px',
        paddingRight: '3%',
    },
    progressBar: {
            color: colors[mode].cardImageTextRBCHover
        },
        resendVerification: {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'row',
            height: '25px',
            justifyContent: 'center',
            marginLeft: '41px',
            [theme.breakpoints.down('sm')]: {
                width: '100%'
            },
            marginTop: '7px'
        },
        countdown: {
            marginLeft: '14px',
            marginTop: '5px',
            position: 'relative'
        },
        countdownEmpty: {
            marginLeft: '14px',
            marginTop: '6px',
            position: 'relative',
            width: '25px'
        },
        countdownErr: {
            marginLeft: 0
        },
        helpText: {
        fontStyle: 'italic',
        // marginTop: '35px',
        padding: '18px 24px',
        [theme.breakpoints.down('md')]: {
            padding: '7px 24px'
        },
        [theme.breakpoints.down('sm')]: {
            padding: '0px 24px 0px 24px',
        }
    },
     helpTextVerified: {
        padding: '11% 24px 0 24px'
    },
        countdownTypography: {
            color: colors[mode].cardImageTextRBCHover,
            fontFamily: 'Roboto',
            fontStyle: '10px',
            fontWeight: 400,
            left: '50%',
            position: 'absolute',
            top: '42%',
            transform: 'translate(-50%, -50%)'
        },
        disabledLink: {
            alignSelf: 'start',
            color: colors[mode].secondaryText,
            cursor: 'default',
            display: 'flex',
            fontFamily: 'Roboto',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            letterSpacing: '0.17px',
            lineHeight: '20px',
            pointerEvents: 'none'
        },
        link: {
            alignSelf: 'start',
            color: colors[mode].canResendLink,
            cursor: 'pointer',
            display: 'flex',
            fontFamily: 'Roboto',
            fontSize: '14px',
            fontWeight: 400,
            letterSpacing: '0.17px',
            lineHeight: '20px',
            textDecoration: 'underline'
        },
        resendVerificationCall: {
            marginLeft: '55px',
            [theme.breakpoints.down('sm')]: {
                width: '100%'
            }
        },
         resendverificationCode:{
            color: colors[mode].successTextLight,
            fontFamily: 'Roboto',
            fontSize: '14px',
            fontWeight: 400,
            letterSpacing: '0.17px',
            lineHeight: '20px',
            paddingBottom: '2% !important',
            paddingTop: '2% !important'
        },
        resendVerificationSendChallengeErr: {
            marginLeft: '30px'
        },
        resendVerificationSendChallengeErrCallEn: {
            marginTop: '15px',
            width: '145px'
        },
        resendVerificationSendChallengeErrCallFr: {
            marginTop: '25px',
            width: '180px'
        },
        resendVerificationSendChallengeErrSmsEn: {
            marginTop: '5px',
            width: '150px'
        },
        resendVerificationSendChallengeErrSmsFr: {
            marginTop: '5px',
            width: '180px'
        },
    verificationCodeBox: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            marginTop: '50px'
        },
        verificationCodeBoxCall: {
            width: '190px',
            [theme.breakpoints.down('sm')]: {
                marginTop: '25px'
            }
        },
        verificationCodeBoxSMS: {
            width: '220px'
        },
        verificationCodeInput: {
            '&:focus': {
                border: 'none',
                outline: 'none'
            },
            background: colors[mode].primaryBackground,
            border: 'none',
            borderBottom: `2px solid ${colors[mode].verificationCodeInputFilledBorder}`,
            borderRadius: '2px',
            boxShadow: 'none',
            color: colors[mode].primaryText,
            fontFamily: 'Roboto',
            fontSize: '14px',
            fontWeight: 400,
            height: '40px',
            letterSpacing: '0.15px',
            lineHeight: '20px',
            textAlign: 'center',
            width: '30px'
        },
        verificationCodeInputContainer: {
            display: 'flex',
            flexDirection: 'row',
            gap: '8px'
        },
        verificationCodeLabel: {
            color: colors[mode].verificationCodeLabel,
            fontFamily: 'Roboto',
            fontSize: '12px',
            fontWeight: 400,
            letterSpacing: '0.15px',
            lineHeight: '12px',
            marginBottom: '6px'
        },
        verificationContainer: {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            justifyContent: 'flex-start'
        },
        verificationError: {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'row',
            gap: '5px',
            justifyContent: 'center',
            marginTop: '13px'
        },
        verificationErrorIcon: {
            color: colors[mode].errorText,
            height: '24px',
            marginLeft: '8px',
            width: '24px'
        },
        verificationErrorText: {
            color: colors[mode].errorText,
            fontFamily: 'Roboto',
            fontSize: '14px',
            fontWeight: 400,
            letterSpacing: '0.17px',
            lineHeight: '20px'
        },
        verificationStatusContainer: {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start'
        },
        verificationSuccess: {
            alignItems: 'center',
            display: 'flex',
            gap: '5px',
            flexDirection: 'row',
            justifyContent: 'center',
            marginTop: '13px'
        },
        verificationSuccessIcon: {
            color: colors[mode].successText,
            height: '24px',
            marginLeft: '8px',
            width: '24px'
        },
        verificationSuccessText: {
            color: colors[mode].successTextLight,
            fontFamily: 'Roboto',
            fontSize: '14px',
            fontWeight: 400,
            letterSpacing: '0.17px',
            lineHeight: '20px'
        }
       
}
}
